export const API_URL = "https://backend.redapalpa.org.np/api/";
export const Username = "redapalpa";
export const Password = "reda12345!!";